import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { mergeClassName } from '@/utils/mergeClassName';

const lockIconStyles = cva('z-20', {
  variants: {
    color: {
      white: 'text-white',
      grey: '#374151',
    },
    position: {
      relative: 'relative',
      left: 'absolute top-4 left-4',
      right: 'absolute top-4 right-4',
    },
  },
  defaultVariants: {
    color: 'white',
    position: 'left',
  },
});

export interface LockIconProps extends VariantProps<typeof lockIconStyles> {
  className?: string;
}

const LockIcon: React.FC<LockIconProps> = ({ color = 'white', position = 'left', className }) => {
  return (
    <svg
      data-cy='lock-icon'
      className={mergeClassName([lockIconStyles({ color, position }), className])}
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 18 18'
      fill='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M13.142 5.547V6.69701C14.4338 7.10022 15.375 8.2696 15.375 9.6663V13.369C15.375 15.0981 13.9415 16.5 12.1742 16.5H5.8266C4.05852 16.5 2.625 15.0981 2.625 13.369V9.6663C2.625 8.2696 3.56696 7.10022 4.85796 6.69701V5.547C4.86559 3.31109 6.7175 1.5 8.98857 1.5C11.2901 1.5 13.142 3.31109 13.142 5.547ZM9.00381 2.80428C10.5509 2.80428 11.8084 4.03404 11.8084 5.547V6.53528H6.19165V5.5321C6.19927 4.02658 7.45674 2.80428 9.00381 2.80428ZM9.66684 12.3412C9.66684 12.7064 9.36962 12.9971 8.99619 12.9971C8.63038 12.9971 8.33316 12.7064 8.33316 12.3412V10.6866C8.33316 10.3289 8.63038 10.0382 8.99619 10.0382C9.36962 10.0382 9.66684 10.3289 9.66684 10.6866V12.3412Z'
        fill='url(#paint0_linear_5539_2869)'
      />
      <defs>
        <linearGradient
          id='paint0_linear_5539_2869'
          x1='2.61773'
          y1='8.99673'
          x2='15.3726'
          y2='8.99673'
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#7AD817' />
          <stop offset='1' stopColor='#08B3BD' />
        </linearGradient>
      </defs>
    </svg>
  );
};

export default LockIcon;
